import React, { Component } from 'react';

class FOUR extends Component {
  render() {
    return (
      <div>
          <h1>404 Not Found</h1>
        </div>
    );
  }
}

export default FOUR;


// WEBPACK FOOTER //
// ./src/pages/404.js